import {
  DesktopOutlined,
  EnvironmentOutlined,
  IdcardOutlined,
  PictureOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Button, Card, Space } from 'antd'
import { DeviceTypeSelector } from 'common/components/dictionary/DeviceTypeSelector.tsx'
import { AdGroupSelector } from 'common/components/reloadable/AdGroupSelector.tsx'
import { AdvertiserSelector } from 'common/components/reloadable/AdvertiserSelector.tsx'
import { CampaignSelector } from 'common/components/reloadable/CampaignSelector.tsx'
import { CreativeSelector } from 'common/components/reloadable/CreativeSelector.tsx'
import React, { useState } from 'react'

import { DashboardFilters } from './UseDashboardData.ts'
import { CountryByIsoSelector } from 'common/components/dictionary/CountryByIsoSelector.tsx'

const iconColor = '#6F757E'

interface FilterRowProps {
  icon: React.ReactNode
  children: React.ReactNode
  style?: React.CSSProperties
}

export const FilterRow: React.FC<FilterRowProps> = ({ icon, children, style }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
      <div style={{ width: 30, textAlign: 'center' }}>{icon}</div>
      {children}
    </div>
  )
}

const Filters: React.FC<{
  setFilters: (filters: DashboardFilters) => void
  filters: DashboardFilters
  admin: boolean
}> = ({ setFilters, filters, admin }) => {
  const [selectedCampaignIds, setSelectedCampaignIds] = useState<any>(filters.campaignIds || [])
  const [selectedAdGroupIds, setSelectedAdGroupIds] = useState<any>(filters.adGroupIds || [])
  const [selectedCreativeIds, setSelectedCreativeIds] = useState<any>(filters.creativeIds || [])
  const [selectedCountryCodes, setSelectedCountryCodes] = useState<any>(filters.countryCodes || [])
  const [selectedDeviceTypeIds, setSelectedDeviceTypeIds] = useState<any>(filters.deviceTypes || [])
  const [selectedAdvertiserIds, setSelectedAdvertiserIds] = useState<any>(filters.deviceTypes || [])

  const handleApply = () => {
    const filter: DashboardFilters = {
      campaignIds: selectedCampaignIds.length ? selectedCampaignIds : undefined,
      adGroupIds: selectedAdGroupIds.length ? selectedAdGroupIds : undefined,
      creativeIds: selectedCreativeIds.length ? selectedCreativeIds : undefined,
      countryCodes: selectedCountryCodes.length ? selectedCountryCodes : undefined,
      deviceTypes: selectedDeviceTypeIds.length ? selectedDeviceTypeIds : undefined,
      advertiserIds: selectedAdvertiserIds.length ? selectedAdvertiserIds : undefined,
    }
    setFilters(filter)
  }

  const handleClear = () => {
    setSelectedCampaignIds(undefined)
    setSelectedAdGroupIds(undefined)
    setSelectedCreativeIds(undefined)
    setSelectedCountryCodes(undefined)
    setSelectedDeviceTypeIds(undefined)
    setSelectedAdvertiserIds(undefined)
    setFilters({})
  }

  return (
    <Card
      title="Filters"
      style={{ background: '#FFFFFF', border: 'transparent', minWidth: '300px', height: 'fit-content' }}
      className="dashboard-filters-card"
      styles={{ header: { borderBottom: 'none' } }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <FilterRow icon={<UnorderedListOutlined style={{ color: iconColor }} />}>
          <CampaignSelector
            placeholder="All Campaigns"
            multiple
            value={selectedCampaignIds}
            onChange={setSelectedCampaignIds}
            style={{ flex: 1 }}
          />
        </FilterRow>

        <FilterRow icon={<IdcardOutlined style={{ color: iconColor }} />}>
          <AdGroupSelector
            placeholder="All AdGroups"
            multiple
            value={selectedAdGroupIds}
            onChange={setSelectedAdGroupIds}
            style={{ flex: 1 }}
          />
        </FilterRow>

        <FilterRow icon={<PictureOutlined style={{ color: iconColor }} />}>
          <CreativeSelector
            placeholder="All Creatives"
            multiple
            value={selectedCreativeIds}
            onChange={setSelectedCreativeIds}
            style={{ flex: 1 }}
          />
        </FilterRow>

        <FilterRow icon={<EnvironmentOutlined style={{ color: iconColor }} />}>
          <CountryByIsoSelector
            placeholder="All Countries"
            value={selectedCountryCodes}
            onChange={setSelectedCountryCodes}
            style={{ flex: 1 }}
          />
        </FilterRow>

        <FilterRow icon={<DesktopOutlined style={{ color: iconColor }} />}>
          <DeviceTypeSelector
            placeholder="All Devices"
            multiple
            value={selectedDeviceTypeIds}
            onChange={setSelectedDeviceTypeIds}
            style={{ flex: 1 }}
          />
        </FilterRow>

        {admin && (
          <FilterRow icon={<UserOutlined style={{ color: iconColor }} />}>
            <AdvertiserSelector
              placeholder="All Advertisers"
              multiple
              value={selectedAdvertiserIds}
              onChange={setSelectedAdvertiserIds}
              style={{ flex: 1 }}
            />
          </FilterRow>
        )}

        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Button type="primary" block onClick={handleApply} style={{ marginLeft: 10, width: 250 }}>
            Show Results
          </Button>
          <Button style={{ border: 'transparent' }} block onClick={handleClear}>
            Clear All
          </Button>
        </Space>
      </Space>
    </Card>
  )
}

export default Filters
